module.exports = __webpack_public_path__ + "img/fortinet-logo.a94278f9.png";